<!-- TripRowContent.vue -->
<script setup>
import { useFormatStore } from "@/stores/formatStore";
import {VueSpinner} from "vue3-spinners";

const props = defineProps({
  trip: Object,
  defaultImage: String,
  addingSlug: [String, Number],
});

const formatStore = useFormatStore();


</script>

<template>
  <div>
    <div>
      <img class="max-w-10 h-8 rounded-sm object-fit" :src="trip.backgroundImageUrl || defaultImage" alt="Trip">
    </div>
    <div class="flex flex-col">
      <div class="responsive-body-small font-semibold">
        {{ trip.name && trip.name.length > 15 ? trip.name.slice(0, 15) + '...' : trip.name }}
      </div>
      <div class="responsive-body-xxsmall text-gray-500 trip-dates">
        {{ formatStore.formatDateWithMapping(trip.dateStart, 'standard') }}
        -
        {{ formatStore.formatDateWithMapping(trip.dateEnd, 'standard') }}
      </div>
    </div>
    <div class="ml-auto flex items-center">
      <div
          class="responsive-body-xxsmall rounded-11xl flex items-center justify-center p-1 w-6 h-6"
          :style="trip.style"
          :aria-label="addingSlug === trip.uuid ? 'Adding...' : 'Trip status badge'"
      >
        <VueSpinner v-if="addingSlug === trip.uuid" :size="14"/>
        <template v-else>
          <img v-if="trip.state === 'open' || trip.state === 'offer' || trip.state === 'active' || trip.state === 'planned'"
               src="@/assets/icons/svg/Confirmed_16x16.svg" alt="" width="16" height="16"/>
          <img v-else-if="trip.state === 'done'"
               src="@/assets/icons/svg/Completed_16x16.svg" alt="" width="16" height="16"/>
          <img v-else-if="trip.state === 'cancelled'"
               src="@/assets/icons/svg/Cancelled_16x16.svg" alt="" width="16" height="16"/>
        </template>
      </div>
    </div>
  </div>
</template>


